// Item 216 batch 2 — live metadata-URL validator client. Backs the
// SetupWizard's SSO step "Test metadata URL" action: fetches the
// operator-supplied IdP metadata URL server-side and flags the
// "internal URL in metadata" trap (SSO/SLO endpoints only reachable
// from the IdP's own private network). Read-only — nothing is
// persisted, SAML config stays env/file-sourced.

import { parseErrorResponse } from './problem';

export interface SAMLMetadataEndpoint {
  binding: string;
  location: string;
  internal: boolean;
  insecure: boolean;
}

export interface SAMLMetadataTestResult {
  ok: boolean;
  error?: string;
  entity_id?: string;
  sso_endpoints?: SAMLMetadataEndpoint[];
  slo_endpoints?: SAMLMetadataEndpoint[];
  warnings?: string[];
}

export async function testSAMLMetadataURL(metadataURL: string): Promise<SAMLMetadataTestResult> {
  const res = await fetch('/api/admin/saml/metadata/test', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ metadata_url: metadataURL }),
  });
  if (!res.ok) throw await parseErrorResponse(res);
  return res.json();
}
